import animationDefinition from "./definition/animation.js";
import rotationDefinition from "./definition/rotation.js";
import GeneralClassMethod from "../generalClassMethod.js"
import store from '../config.js'
import { v4 as uuidv4, validate as uuidValidate } from 'uuid';
import * as namespaceStore from "../namespaceStore.js"
import specialId from "./definition/specialId.js";

export default class Base extends GeneralClassMethod {
    objectType = "BaseMedia";
    previewId = null;
    _id = null;
    parent = null;
    CanBeHide = true;
    _Show = true;
    _CanChangeName = true;
    _CanBeRemove = true;
    _CanBeDuplicate = true;
    _name = null;
    _playPressAnimation = false;
    _playAnimation = false;
    CanBeCopied = true;
    CanAddElement = true;
    CanBeAltered = true;
    CanBeDeleted = true;
    VisibilityAtTheSameTime = true;
    HideElementType = null;
    constructor(args) {
        super();
    }

    objectToClassValue(args = {}) {
        args = this.constructor.fromObjectToObject(args);
        if (args.previewId == null || args.previewId == "") {
            this.previewId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        }
        else {
            this.previewId = args.previewId;
        }
        this.CanBeDeleted = args.canBeDeleted !== undefined ? args.canBeDeleted : true;
        this.id = args.id && (specialId.includes(args.id) == true || uuidValidate(args.id) == true) ? args.id : uuidv4();
        this.parent = args.parent ? args.parent : null;
        this.Name = args.name ? args.name : null;
        this.CanChangeName = args.canChangeName !== undefined ? args.canChangeName : true;
        this.CanBeRemove = args.canBeRemove !== undefined ? args.canBeRemove : true;
        this.CanBeDuplicate = args.canBeDuplicate !== undefined ? args.canBeDuplicate : true;
        this.Show = args.show !== undefined ? args.show : true;
        this.CanBeHide = args.canBeHide !== undefined ? args.canBeHide : true;
        this.CanAddElement = args.canAddElement !== undefined ? args.canAddElement : true;
        this.CanBeAltered = args.canBeAltered !== undefined ? args.canBeAltered : true;
        this.CanBeCopied = args.canBeCopied !== undefined ? args.canBeCopied : true;
        this.VisibilityAtTheSameTime = args.visibilityAtTheSameTime !== undefined ? args.visibilityAtTheSameTime : true;
        this.HideElementType = args.hideElementType !== undefined ? args.hideElementType : null;
    }

    set playAnimationDeep(value) {
        this.playAnimation = value;
        for (const el of this.constructor.variableOfInstance()) {
            if (el.jsType == "Class" && this[el.property] != null) {
                this[el.property].playAnimationDeep = value;
            }
            else if (el.jsType == "Array" && this[el.property] != null) {
                for (const element of this[el.property]) {
                    if (typeof element === 'object' && !Array.isArray(element) && element !== null) {
                        element.playAnimationDeep = value;
                    }
                }
            }
        }
    }

    get id() {
        if (this._id == null) {
            return this.Name;
        }
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get playPressAnimation() {
        return this._playPressAnimation;
    }
    set playPressAnimation(value) {
        this._playPressAnimation = value;
        setTimeout(() => {
            this._playPressAnimation = false;
        }, 750);
    }
    get playAnimation() {
        return this._playAnimation;
    }
    set playAnimation(value) {
        this._playAnimation = value;
        setTimeout(() => {
            this._playAnimation = false;
        }, 750);
    }
    get addedElementShortCutAction() {
        return [];
    }
    get shortCut() {
        return [];
    }
    get Show() {
        if (this.CanBeHide == false) {
            return true;
        }
        return this._Show;
    }
    set Show(value) {
        if (this.parent) {
            this.parent.setVisibility(this, value);
        }
        else {
            this._Show = value;
        }
    }
    get changeableProperty() {
        return [
            // {name: "Name", type: "textInput", dataType: "string"},
        ];
    }
    set CanChangeName(value) {
        this._CanChangeName = value;
    }
    get CanChangeName() {
        return this._CanChangeName;
    }
    get isBaseElement() {
        return this.parent == null || this.parent.objectType == "CompositionItem";
    }
    static get Name() {
        return "Base";
    }
    set Name(value) {
        this._name = value;
    }
    get Name() {
        if (this._name) {
            return this._name;
        }
        return this.constructor.Name;
    }
    set CanBeRemove(value) {
        this._CanBeRemove = value;
    }
    get CanBeRemove() {
        return this._CanBeRemove;
    }
    set CanBeDuplicate(value) {
        this._CanBeDuplicate = value;
    }
    get CanBeDuplicate() {
        if (this._CanBeDuplicate == true && (this.parent == null || this.parent.objectType != "CompositionItem")) return true;
        return false;
    }
    get CanBeMove() {
        if (this.parent == null || this.parent.objectType != "CompositionItem") return true;
        return false;
    }
    setVisibility(element, value) {
        if (this.VisibilityAtTheSameTime == true) {
            if (element.objectType == "ContainerItem" && element.parent && element.parent.objectType == "CompositionItem") {
                // cas particulier pour l'image dynamique et les compositions. Il n'est pas possible de définier VisibilityAtTheSameTime à false car il existe que un seul Live par composition.
                // On force donc toutes les Live des compositions à être cachées quand on en affiche ou cache une.
                const composition = store.getters[namespaceStore.THEME + "/compositions"];
                composition.forEach(el => {
                    if (!el.Live.HideElementType || el.Live.HideElementType == element.objectType) {
                        el.Live._Show = false;
                    }
                });
            }
            element._Show = value;
        }
        else {
            let contain = this.Contain || this.Contents;
            if (contain) {
                for (const el of contain) {
                    if (!this.HideElementType || this.HideElementType == el.objectType) {
                        el._Show = false;
                    }
                }
                element._Show = value;
            }
            else {
                element._Show = value;
            }
        }
    }
    static fromObjectToObject(object) {
        return object;
    }
    static fromObject(object) {
        return new this.prototype.constructor(object);
    }
    static variableOfInstance() {
        return [
            { property: "id", construct: Number, jsType: "Number" },
            { property: "previewId", construct: String, jsType: "String" },
            { property: "objectType", construct: String, jsType: "String" },
            { property: "Name", construct: String, jsType: "String" },
            { property: "playPressAnimation", construct: Boolean, jsType: "Boolean" },
            { property: "playAnimation", construct: Boolean, jsType: "Boolean" },
            { property: "CanBeMove", construct: Boolean, jsType: "Boolean" },
            { property: "CanBeDuplicate", construct: Boolean, jsType: "Boolean" },
            { property: "CanBeRemove", construct: Boolean, jsType: "Boolean" },
            { property: "CanChangeName", construct: Boolean, jsType: "Boolean" },
        ]; 
    }

    getIdFromText(text, objectToWatch) {
        return this.constructor.getIdFromText(text, objectToWatch);
    }
    static getIdFromText(text, objectToWatch) {
        let findedObject = objectToWatch.find(object => {
            if (text == object.name || text == object.url || text == object.path) {
                return true;
            }
            return false;
        });
        if (findedObject != undefined && findedObject != null && findedObject.idSoft != null) {
            return findedObject.idSoft;
        }
        return null;
    }
    heavyClone() {
        return this.constructor.fromObject(JSON.parse(JSON.stringify(this.toObject())));
    }
    getParentSize(grided={x: 1, y: 1, gap: 0}) {
        if (!this.parent) return {x: 0, y: 0, width: 0, height: 0};
        if (!this.parent.Position) {
            if (this.parent.objectType == "GridElement") {
                grided.x = this.parent.X;
                grided.y = this.parent.Y;
                grided.gap = this.parent.Gap;
            }
            let sizeParent = this.parent.getParentSize(grided);
            let rotation = rotationDefinition.find(rotation => rotation.idSoft == this.parent.Rotation);
            return rotation.sizeAction(sizeParent.width, sizeParent.height);
        }
        return {
            width: this.parent.Position ? (this.parent.Position.width - (grided.gap * (grided.x - 1))) / grided.x : 0,
            height: this.parent.Position ? (this.parent.Position.height - (grided.gap * (grided.y - 1))) / grided.y : 0,
        }
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            objectType: this.objectType,
            id: this.id,
            // name: this.Name,
        };
    }
    toObject(minify = false) {
        let r = {
            objectType: this.objectType,
            id: this.id,
            name: this.Name,
            visibilityAtTheSameTime: this.VisibilityAtTheSameTime,
            canBeCopied: this.CanBeCopied,
        }
        if (minify == false) {
            r.previewId = this.previewId;
            r.show = this.Show;
            r.canBeHide = this.CanBeHide;
            r.canChangeName = this.CanChangeName;
            r.canBeRemove = this.CanBeRemove;
            r.canBeDuplicate = this.CanBeDuplicate;
            r.canBeDeleted = this.CanBeDeleted;
        }
        return r
    }
    toJSON() {
        return JSON.stringify(this.toObject());
    }
    getAnimationClass(currentElementIndex = null) {
        let classReturn = {}
        let animation = null;
        if (currentElementIndex == this.previewId) {
            classReturn["selected"] = true;
        }
        if (this.playAnimation && this.Animation) {
            animation = animationDefinition.find(animation => animation.idSoft == this.Animation);
            classReturn = animation.action(classReturn);
        }
        if (this.playPressAnimation && this.PressAnimation) {
            animation = animationDefinition.find(animation => animation.idSoft == this.PressAnimation);
            classReturn = animation.action(classReturn);
        }
        return classReturn;
    }
    getStyle(currentElementIndex = null) {
        if (this.isDraggable == false) {
            return {
                opacity: this.Show ? 1 : 0,
                pointerEvents: this.Show ? 'auto' : 'none',
                cursor: 'inherit'
            };
        }
        else {
            return {
                cursor: 'move',
                pointerEvents: this.Show ? 'auto' : 'none',
                opacity: this.Show ? 1 : 0
            };
        }
    }
    getBaseElementById(id) {
        if (this.hasPreviewId(id) == true) {
            if (this.isBaseElement == true) {
                return this;
            }
            else {
                return true;
            }
        }
        let p = this.changeableProperty;
        for (const property of p) {
            if (property.type == "objectInput" && this[property.name] != null) {
                let result = this[property.name].getBaseElementById(id);
                if (result != null && result != false && this.isBaseElement == true) {
                    return this;
                }
                else if (result != null && result != false && this.isBaseElement == false) {
                    return true;
                }
            }
            else if (property.type == "arrayInput" && this[property.name] != null && this[property.name].length > 0) {
                for (const element of this[property.name]) {
                    let result = element.getBaseElementById(id);
                    if (result != null && result != false && this.isBaseElement == true) {
                        return this;
                    }
                    else if (result != null && result != false && this.isBaseElement == false) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    getElementBy(type, value) {
        if (this[type] && this[type] == value) return this;
        let p = this.changeableProperty;
        for (const property of p) {
            if (property.type == "objectInput" && this[property.name] != null) {
                let result = this[property.name].getElementBy(type, value);
                if (result != null) {
                    return result;
                }
            }
            else if (property.type == "arrayInput" && this[property.name] != null && this[property.name].length > 0) {
                for (const element of this[property.name]) {
                    let result = element.getElementBy(type, value);
                    if (result != null) {
                        return result;
                    }
                }
            }
        }
        return null;
    }
    getParentFromPreviewId(id) {
        if (this.hasPreviewId(id) == true) {
            return true;
        }
        let p = this.changeableProperty;
        for (const property of p) {
            if (property.type == "objectInput" && this[property.name] != null) {
                let result = this[property.name].getParentFromPreviewId(id);
                if (result != null && typeof result == "boolean" && result == true)
                    return {parent: this, property: property};
                else if (result != null && typeof result == "object") {
                    return result;
                }
            }
            else if (property.type == "arrayInput" && this[property.name] != null && this[property.name].length > 0) {
                for (const element of this[property.name]) {
                    let result = element.getParentFromPreviewId(id);
                    if (result != null && typeof result == "boolean" && result == true)
                        return {parent: this, property: property};
                    else if (result != null && typeof result == "object") {
                        return result;
                    }
                }
            }
        }
        return false;
    }
    hasPreviewId(id) {
        return this.previewId == id;
    }
    hexStringToRgbaObject(hex) {
        const matches = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i.exec(hex);
        return matches ? {
            r: parseInt(matches[1], 16),
            g: parseInt(matches[2], 16),
            b: parseInt(matches[3], 16),
            a: matches[4] ? parseFloat(matches[4], 16) / 255 : 1
        } : null;
    }
    rgbaStringToRgbString(rgbaString) {
        const rgba = this.RgbaStringToRgbaObject(rgbaString);
        return `rgb(${rgba.r}, ${rgba.g}, ${rgba.b})`;
    }
    RgbaStringToRgbaObject(rgbString) {
        if (rgbString.startsWith('rgb')) {
            const matches = rgbString.match(/rgb.\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
            if (matches) {
                return {
                    r: parseInt(matches[1]),
                    g: parseInt(matches[2]),
                    b: parseInt(matches[3]),
                    a: parseFloat(matches[4])
                }
            }
        }
        return null;
    }
    colorStringToRgbaObject(colorString) {
        return colorString.startsWith("#") ? this.hexStringToRgbaObject(colorString) : this.RgbaStringToRgbaObject(colorString);
    }
    harmonizeColorValue(value) {
        if (value) {
            const rgba = value.startsWith("#") ? this.hexStringToRgbaObject(value) : this.RgbaStringToRgbaObject(value);
            if (rgba) {
                return `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`;
            }
        }
        return "rgba(0, 0, 0, 0)";
    }


    hexStringFromNumber(number) {
        return number.toString(16).toUpperCase().padStart(2, '0');
    }
    hexColorValue(value) {
        if (value) {
            const rgba = value.startsWith("#") ? this.hexStringToRgbaObject(value) : this.RgbaStringToRgbaObject(value);
            if (rgba) {
                return `#${this.hexStringFromNumber(rgba.a * 255)}${this.hexStringFromNumber(rgba.r)}${this.hexStringFromNumber(rgba.g)}${this.hexStringFromNumber(rgba.b)}`;
            }
        }
        return undefined;
    }
    getFromPreviewId(id) {
        if (this.hasPreviewId(id) == true)
            return this;
        return null;
    }
    get isDraggable() {
        return false;
    }
    opacityStyle(property) {
        if (this[property]) {
            const rgba = this[property].startsWith("#") ? this.hexStringToRgbaObject(this[property]) : this.RgbaStringToRgbaObject(this[property]);
            if (rgba) {
                return {
                    opacity: rgba.a
                };
            }
        }
        return {};
    }
    updateSize(deltaX = 0, deltaY = 0, direction = "left") {
        if (this.Position == null) {
            return;
        }
        if (this.Position != null) {
            if (direction.includes("left")) {
                if (this.Position.width - deltaX <= 0)
                    deltaX = Math.max(this.Position.width, 1) - 1;
                if (this.Position.x + deltaX < 0)
                    deltaX = -this.Position.x;
                this.Position._x += deltaX;
                this.Position._width -= deltaX;
            }
            if (direction.includes("right")) {
                if (this.Position.x + this.Position.width + deltaX > this.Position.maxSizeX && this.Position.maxSizeX != -1) {
                    deltaX = this.Position.maxSizeX - (this.Position.x + this.Position.width);
                }
                if (this.Position.width + deltaX <= 0)
                    deltaX = 1 - this.Position.width;
                this.Position._width += deltaX;
            }
            if (direction.includes("top")) {
                if (this.Position.height - deltaY <= 0)
                    deltaY = Math.max(this.Position.height, 1) - 1;
                if (this.Position.y + deltaY < 0)
                    deltaY = -this.Position.y;
                this.Position._y += deltaY;
                this.Position._height -= deltaY;
            }
            if (direction.includes("bottom")) {
                if (this.Position.y + this.Position.height + deltaY > this.Position.maxSizeY && this.Position.maxSizeY != -1) {
                    deltaY = this.Position.maxSizeY - (this.Position.y + this.Position.height);
                }
                if (this.Position.height + deltaY <= 0)
                    deltaY = -this.Position.height + 1;
                this.Position._height += deltaY;
            }
        }
    }
    updatePosition(deltaX, deltaY) {
        if (this.Position == null) {
            return;
        }
        if (this.Position != null) {
            if (this.Position.x + deltaX < 0) {
                this.Position._x = 0;
            }
            else if (this.Position.x + this.Position.width + deltaX > this.Position.maxSizeX && this.Position.maxSizeX != -1) {
                this.Position._x = this.Position.maxSizeX - this.Position.width;
            }
            else {
                this.Position._x += deltaX;
            }
            if (this.Position.y + deltaY < 0) {
                this.Position._y = 0;
            }
            else if (this.Position.y + this.Position.height + deltaY > this.Position.maxSizeY && this.Position.maxSizeY != -1) {
                this.Position._y = this.Position.maxSizeY - this.Position.height;
            }
            else {
                this.Position._y += deltaY;
            }
        }
        else {
            this.Position._x += deltaX;
            this.Position._y += deltaY;
        }
    }
}
